const CONFIG = window.GS_THEME_EXPERIMENT_CONFIG || {};
const EVENT_NAME = 'gs_theme_exposure';
const SHOPIFY_EVENT_NAME = `gs:${EVENT_NAME}`;
const MAX_PUBLISH_ATTEMPTS = 50;
const RETRY_DELAY_MS = 100;

if (!window.__gsThemeExperimentExposureLoaded) {
  window.__gsThemeExperimentExposureLoaded = true;

  function textValue(value) {
    if (value === undefined || value === null) return '';
    return String(value).replace(/\s+/g, ' ').trim().slice(0, 180);
  }

  function isPreviewContext() {
    const hostname = window.location.hostname;

    return Boolean(
      window.Shopify?.designMode ||
        hostname.endsWith('.shopifypreview.com') ||
        document.querySelector(
          'script[src*="preview-bar"], script[src*="preview_bar"], iframe[src*="preview-bar"], iframe[src*="preview_bar"]'
        )
    );
  }

  function payload() {
    return {
      source_feature: 'website_2_experiment',
      environment: isPreviewContext() ? 'preview' : 'production',
      website_version: textValue(CONFIG.websiteVersion),
      experiment_id: textValue(CONFIG.experimentId),
      experiment_arm: textValue(CONFIG.experimentArm),
      surface: 'sitewide',
      module: 'theme_experiment',
      page_type: textValue(CONFIG.pageType),
      template_name: textValue(CONFIG.templateName),
      theme_id: textValue(CONFIG.themeId),
      theme_name: textValue(CONFIG.themeName),
      theme_role: textValue(CONFIG.themeRole),
      page_path: window.location.pathname,
      device_type: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
    };
  }

  function publishExposure() {
    if (typeof window.Shopify?.analytics?.publish !== 'function') return false;

    const eventPayload = payload();
    window.Shopify.analytics.publish(SHOPIFY_EVENT_NAME, eventPayload);
    window.dispatchEvent(
      new CustomEvent('gs:analytics', {
        detail: { eventName: EVENT_NAME, payload: eventPayload },
      })
    );
    document.documentElement.dataset.gsExperimentArm = eventPayload.experiment_arm;
    document.documentElement.dataset.gsExperimentId = eventPayload.experiment_id;
    document.documentElement.dataset.gsExperimentEnvironment = eventPayload.environment;
    return true;
  }

  function start() {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;

      if (publishExposure() || attempts >= MAX_PUBLISH_ATTEMPTS) {
        window.clearInterval(timer);
      }
    }, RETRY_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}
